/**
 * Document Intake is shown only when BOTH are on (Andrew, 16 Oct): the deploy flag `VITE_DOCUMENT_INTAKE` (dev only) and
 * this browser's `?x=intake` switch (off by default; `?x=-intake` turns it off again). Antonin's UI rules: anything new
 * in look or behaviour sits behind a `?x=` switch, ranked "testing" in SHOWCASE-CHANGELOG.md.
 */
import { env } from '@/config/env';
import { isDevHost } from '@/config/dev-host';
import { isEncounterFlagOn } from '@/shared/lib/encounter-flags';

export const isIntakeOn = (): boolean => env.documentIntakeEnabled && isEncounterFlagOn('intake');

/**
 * Chart "Add document" through Document Intake (PROD-3204, Andrew): the deploy flag plus this browser's `?x=chart-intake`
 * switch (off by default). It does not need `?x=intake`; the chart then shows the intake view and its "Add document" starts
 * the intake upload instead of the file popup. PA has no per-clinic `documentIntake` read, so the server's
 * `intake_disabled` answer is the clinic gate (the view falls back to the filed list).
 */
// Dev hosts only (`isDevHost`: localhost and the deployed dev site; qa, uat, prod and unknown hosts are not dev, and no window fails closed),
// so it can never be on in a production build, whatever the build flag or the browser's switch says.
export const isChartIntakeOn = (): boolean => isDevHost() && env.documentIntakeEnabled && isEncounterFlagOn('chartIntake');

/** PROD-3339: the inbox rows' type picker (`?x=intake-type`), only where the intake view itself is on. */
export const isIntakeTypePickerOn = (): boolean => (isIntakeOn() || isChartIntakeOn()) && isEncounterFlagOn('intakeType');
